import AnimationWrapper from './animationwrapper'

export default AnimationWrapper
